import { useFetch } from "./useFetch";

export const useGetPosts = (postID) => {

    const graphqlEndpoint = `${wpGraphQLSettings.root}/graphql`;
    const query = {
        query: `{
            posts {
              nodes {
                id
                title
              }
            }
          }`,
      }

    // fetch data
    const {data:response, isLoading} = useFetch({url: graphqlEndpoint, requestOptions: {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(query) }});
    const data = response?.data;

    return {data, isLoading};

}